<app-main-header [breadcrumbs]="breadcrumbs"></app-main-header>
<ion-content>
  <lib-fields-edit
    (breadcrumbsChange)="onBreadcrumbsUpdated($event)"
  ></lib-fields-edit>
</ion-content>
